import { DocumentData } from 'firebase/firestore'
import { Data } from 'react-firebase-hooks/firestore/dist/firestore/types'
import handWave from '../../assets/hand-wave.png'
import { AppDownloadButtons } from '../../shared-components/AppDownloadButtons'
import { useScreenTracking } from '../../shared-hooks/useScreenTracking'
import { SignupCard } from './SignupCard'

type ExistingAccountProps = {
  userData: Data<DocumentData, '', ''>
}
export const ExistingAccount = ({
  userData,
}: ExistingAccountProps): JSX.Element => {
  useScreenTracking('ExistingAccountView', 'View existing account screen')

  const heading = userData ? `Hey ${userData.first_name}!` : 'Hey!'

  return (
    <SignupCard
      iconSrc={handWave}
      heading={heading}
      subheading='Looks like you already have an account. Download the app to access your guarantees.'
    >
      <AppDownloadButtons />
    </SignupCard>
  )
}
